export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_ERROR = 'ORDER_ERROR';
export const OTHER_ERROR = 'OTHER_ERROR';



// WEBPACK FOOTER //
// ./app/states/payment-process/constants/message-types.ts